const BASE_URL = process.env.NODE_ENV === "development" ? 'http://localhost:5200' : process.env.REACT_APP_API_URL ;

interface ApiEnvelope<T> {
  success: boolean;
  resultObj: T;
  message: string;
  displayMessage: string;
}

export async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const headers = new Headers(options?.headers);
  if (!(options?.body instanceof FormData) && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  const res = await fetch(`${BASE_URL}${path}`, {
    ...options,
    headers,
  });

  const data: ApiEnvelope<T> = await res.json();

  if (!res.ok || !data.success) {
    throw new Error(data.message || `Request failed with status ${res.status}`);
  }

  return data.resultObj;
}
